import React from 'react';
import styled from 'styled-components/macro';
import { Layout } from 'components/organisms';
import { MediaUploadForm } from 'containers';
import { Title } from 'components/atoms';
import { useRouterContext } from 'hooks';

const ThePage = () => {
  const { history, match: { params: { subweb } } } = useRouterContext();

  const handleOnSubmitImage = ({ id }) => {
    history.push(`/${subweb}/assets/${id}`)
  }

  return (
    <Layout>
      <Page>
        <Page.Header>
          <Title>Carregar imagem</Title>
        </Page.Header>
        <MediaUploadForm
          initialValues={{}}
          onSubmit={handleOnSubmitImage}
        />
      </Page>
    </Layout>
  );
}

const Page = styled.div``;

Page.Header = styled.div`
  margin-bottom: ${props => props.theme.spacing.l};
`;

export default ThePage;
